import { EmailClientService } from './../service/email-client.service';
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Location } from '@angular/common';
import { from, of } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GoogleApiService } from '../../scheduling/google-api.service';
import { catchError, concatMap, toArray, map, take, switchMap } from 'rxjs/operators';
import { Buffer } from 'buffer';
import { ToastrService } from 'ngx-toastr';
import { CustomErrorToastComponent } from 'custom-error-toast';
@Component({
  selector: "google-email-client-detail",
  templateUrl: "./google-email-client-detail.component.html",
  styleUrls: ["./google-email-client-detail.component.scss"],
})
export class GoogleEmailClientDetailComponent implements OnInit {
  @Input('selRow') selRow: string = '';
  @Input('emailId') emailId: string = '';
  @Input('emailType') emailType: string = '';
  @Output('eventType') eventType: EventEmitter<string> = new EventEmitter<string>();
  emailDetails: any;
  attachmentData: string[] = [];
  previousUrl: string = null;
  currentUrl: string = null;
  // emailType:string;
  googleMessageType: string;
  conversationDetails: Array<any> = [];
  replyDataList = [
    {
      name: "Reply",
      code: "reply",
    },
    {
      name: "Reply All",
      code: "replyAll",
    },
    {
      name: "Forward",
      code: "forward",
    },
  ];
  constructor(private location: Location,
    private ngxService: NgxUiLoaderService,
    private readonly googleApi: GoogleApiService,
    private toastr: ToastrService,
    private emailClientService: EmailClientService) {
  }
  ngOnInit(): void {
    if (this.selRow) {
      this.getEmailDetails();
    }
    else {
      this.onBack();
    }
    this.googleApi.selectedReplyType = '';
    this.googleMessageType = this.googleApi.googleMessageType
  }

  onBack() {
    this.emailClientService.emailDetailSubscription$.next({ read: false });
    this.emailClientService.folderChangeSubject$.next(true);
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || ''
    sliceSize = sliceSize || 512

    var byteCharacters = atob(b64Data)
    var byteArrays = []

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize)

      var byteNumbers = new Array(slice.length)
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      var byteArray = new Uint8Array(byteNumbers)

      byteArrays.push(byteArray)
    }

    var blob = new Blob(byteArrays, { type: contentType })
    let urlBlob = URL.createObjectURL(blob)
    return urlBlob
  }


  onReplyChange(eventType: string, emailId) {
    let detailsObj = {
      read: false,
      emailId: emailId,
      emailType: 'compose-mail',
      replyType: eventType
    };
    this.emailClientService.emailDetailSubscription$.next(detailsObj);
    this.googleApi.selectedEmailId = emailId;
    this.googleApi.selectedReplyType = eventType;
    if (this.googleMessageType === "DRAFT") {
      this.googleApi.preservedMsgTypeForDraft = this.googleMessageType;
    }
  }


  onDownloadClick(fileData: any) {
    let dataBase64Rep = fileData.data.replace(/-/g, '+').replace(/_/g, '/');
    let urlBlob = this.b64toBlob(dataBase64Rep, fileData.mimeType, fileData.size)
    const downloadLink = document.createElement('a');
    downloadLink.href = urlBlob;
    downloadLink.download = fileData.filename;
    downloadLink.click();
  }

  getEmailDetails() {
    const label = this.googleApi.googleMessageType ? this.googleApi.googleMessageType : 'INBOX';
    const messageId = this.selRow['id'];
    const attachmentArr = [];
    this.conversationDetails = [];
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const userId = userInfo.info.email;
    //Email Details
    this.ngxService.start();
    this.googleApi.getGmailThreadOnId(messageId, userId, label)
      .pipe(
        catchError(err => {
          this.ngxService.stop();
          this.onBack(); //Redirect to INBOX switch to outlook & gmail issue
          return of({});
        })
      )
      .pipe(
        map((threads: any) => {
          let filterItem=[];
          if (label === 'INBOX') {
            filterItem = threads.messages.map(x => x.labelIds).join().split(',').filter(v => v !== 'SENT' && v !== 'TRASH');
            if (filterItem.length > 0) {
              return threads.messages;
            } else {
              return [];
            }
          } else {
              threads?.messages?.forEach((item: any) => {
                if (item.labelIds.includes(label)) {
                  filterItem.push(item)
                }
              })
            return filterItem;
          }
        })
      )
      .subscribe(gmailData => {
        if (gmailData.length > 0) {
          from(this.sortByKey(gmailData, 'internalDate'))
            .pipe(
              map((mailData: any) => {
                const filterMsg = mailData['payload']['headers']
                  .filter(header => header.name == "From" || header.name == "To" ||
                    header.name == "Cc" || header.name == "Subject" || header.name == "Date");
                this.emailDetails = filterMsg.reduce(
                  (obj, item) => Object.assign(obj, { [item.name]: item.value }), {});
                let editorFlag = false;
                try {
                  editorFlag = mailData['payload']['parts'][1]['body'].hasOwnProperty('data');
                }
                catch (e) {
                  editorFlag = false;
                  this.ngxService.stop();
                }
                let editorValue = '';
                if (editorFlag) {
                  let dataBase64Rep = mailData['payload']['parts'][1].body.data.replace(/-/g, '+').replace(/_/g, '/');
                  editorValue = atob(dataBase64Rep);
                }
                else {
                  try {
                    if (mailData['payload']['parts'][0]['mimeType'] == "multipart/alternative") {
                      for (let item of mailData['payload']['parts'][0]['parts']) {
                        if (item.mimeType == "text/html") {
                          let dataBase64Rep = item?.body?.data.replace(/-/g, '+').replace(/_/g, '/');
                          editorValue = atob(dataBase64Rep);
                          // editorValue = "<br/>" + Buffer.from(item?.body?.data, 'base64').toString('utf8');
                          // break;
                        }
                      }
                    }
                  }
                  catch (e) { this.ngxService.stop(); }

                  try {
                    if (mailData['payload']['body']['data']) {
                      let dataBase64Rep = mailData['payload']['body']['data'].replace(/-/g, '+').replace(/_/g, '/');
                      editorValue = atob(dataBase64Rep);
                      // editorValue = "<br/>" + Buffer.from(mailData['payload']['body']['data'], 'base64').toString('utf8');
                    }
                  }
                  catch (e) {

                  }
                }
                let downloadArr = [];
                try {
                  mailData['payload']['parts'].forEach(parts => {
                    if (parts.filename) {
                      downloadArr.push({ filename: parts.filename, attachmentId: parts.body.attachmentId, mimeType: parts.mimeType })
                    }
                  })
                }
                catch (e) { }
                // Mark Email as read
                try {
                  if (mailData['labelIds'].includes('UNREAD')) {
                    this.markEmailAsRead(userId, mailData['id']);
                  }
                }
                catch (e) { }
                const snippets = {
                  'shortSnippet': mailData.snippet.slice(0, 160),
                  'snippet': editorValue,
                  id: mailData['id'],
                  threadId: mailData['threadId'],
                  downloadArr: downloadArr
                }
                this.emailDetails = Object.assign(this.emailDetails, snippets);
                return this.emailDetails;
              })

            ).subscribe(data => {
              if (data.downloadArr.length) {
                from(data.downloadArr).pipe(concatMap((downloads: string) => {
                  if (downloads['attachmentId']) {
                    return this.googleApi.getGmailAttachment(data.id, userId, btoa(downloads['attachmentId']))
                  }
                  else {
                    of([]);
                  }
                }), toArray()).toPromise()
                  .then((attachments: any) => {
                    if (data.downloadArr.length === attachments.length) {
                      for (let index in data.downloadArr) {
                        attachments[index] = { ...attachments[index], filename: data.downloadArr[index]['filename'], mimeType: data.downloadArr[index]['mimeType'] }
                      }
                      this.attachmentData = attachments;
                      this.conversationDetails.push({ 'emailDetails': data, attachments: attachments });
                    }
                  })
              }
              else {
                this.conversationDetails.push({ 'emailDetails': this.emailDetails, attachments: [] })
              }
              this.ngxService.stop();
            })
        }
        else {
          this.onBack();
        }
      });
  }

  sortByKey(array, key) {
    return array.sort(function (a, b) {
      var x = a[key]; var y = b[key];
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  markEmailAsRead(userId: string, id: string) {
    let message = {
      "removeLabelIds": [
        "UNREAD"
      ]
    };
    this.googleApi.markEmailRead(userId, id, message).subscribe(data => {
      console.log("updated message read flag.");
    })
  }

  toggleMultiEmail(i, conversation){
    if(i==this.conversationDetails.length-1){
      conversation.isExpanded=true
    }
    conversation.isExpanded = !conversation.isExpanded;
  }

  deleteEmail(messageId: string, index: number) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const userId = userInfo.info.email;
    this.googleMessageType = this.googleApi.googleMessageType;
    if (this.googleMessageType == "TRASH") {
      this.googleApi.deleteEmailPermanently(userId, messageId)
        .pipe(
          catchError(error => {
            return of([]);
          })
        )
        .subscribe((message: any) => {
          if ((message.status === 200 || message.status === 204)) {
            this.conversationDetails.splice(index, 1);
            this.toastr.success("Email Deleted permanently.");
            this.emailClientService.folderChangeSubject$.next(true);
            this.onBack();
          }
          else {
            // Handle 204 by passing something return 
            this.conversationDetails.splice(index, 1);
            this.toastr.success("Email Deleted permanently.", 'Success');
            this.emailClientService.folderChangeSubject$.next(true);
            this.onBack();
          }
        },
          (error) => {
            CustomErrorToastComponent.showErrorToast(this.toastr, 'Problem occured while deleting email.');
          })
    }
    else {
      this.googleApi.moveMessageToTrash(userId, messageId)
        .pipe(
          switchMap(res => res.status === 204 ? of(res.status) : of(res))
        )
        .subscribe((message: any) => {
          if ((message.status === 200 || message.status === 204)) {
            this.conversationDetails.splice(index, 1);
            this.toastr.success("Email Deleted successfully.", 'Success');
            this.emailClientService.folderChangeSubject$.next(true);
            this.onBack();
          }
        },
          (error) => {
            CustomErrorToastComponent.showErrorToast(this.toastr, 'Problem occured while deleting email.');
          })
    }
  }
}
